<template>
    <div>
        <TableList
            :columns="columns"
            :get_table_list="this.get_table_list"
            :slot_table_list="['operation','status']"
            :form_data_seo="form_data_seo"
            ref="list"
        >
            <template slot="left_btn">
                <a-button class="float_left" v-auth="'change'" @click="add()" type="primary">添加帮助</a-button>
            </template>
            <template slot="status" slot-scope="data">
                <a-tag
                    :color="data.text == 0 ? config.color.error : config.color.primary"
                    v-for="item in status_list"
                    :key="item.key"
                    v-show="item.key == data.text"
                >{{item.value}}</a-tag>
            </template>

            <template slot="operation" slot-scope="data">
                <a v-auth="'change'" @click="edit(data.record)">编辑</a>
                <a-divider type="vertical" />

				<a-popconfirm title="您确定要删除吗?" v-auth="'delete'" @confirm="del(data.record)">
					<a>删除</a>
				</a-popconfirm>
            </template>
        </TableList>

        <EditPop
            ref="edit_pop"
            :width="1000"
            @handleSubmit="submit"
            :form_data="form_data"
            :visible.sync="visible"
        >
		
		<div slot='files'>
			<a-upload :showUploadList="false" multiple @change="handleChangeImg($event)" :customRequest="customRequest"
				@preview="handlePreview">
				<a-button>
					<a-icon type="upload" /> 上传
				</a-button>
			</a-upload>
			<div class="file_box">
				<div class="file_li" v-for="(file, file_index) in files_list">
					<!-- <img  v-else src="@/assets/pdf.png" alt=""> -->
					<span @click='seeFileFun(file)'>{{ file.name }} | {{ file.type }} | {{ file.size }}</span>
		
					<a-icon style='color:red;' @click="files_list.splice(index,1)" type="close-circle" />
				</div>
			</div>
		</div>
		
	
		
		</EditPop>
    </div>
</template>

<script>
// @ is an alias to /src
import EditPop from "@/components/EditPop";
import Form from "@/components/Form";
import { getHelpList, changeHelp, getHelp, delHelp, cateList } from "@/api/help";
import { getUploadOSSConfig } from "@/api/public";
import TableList from "@/components/TableList";
import md5 from "js-md5";


const columns = [
    {
        title: "ID",
        dataIndex: "id",
    },
    {
        title: "排序",
        dataIndex: "sort",
    },
    {
        title: "帮助分类",
        dataIndex: "cate",
    },
    {
        title: "帮助标题",
        dataIndex: "title",
    },
    {
        title: "状态",
        dataIndex: "status",
        scopedSlots: {
            customRender: "status"
        }
    },
    {
        title: "创建时间",
        dataIndex: "create_time",
    },
    {
        title: "操作",
        width: 150,
        scopedSlots: {
            customRender: "operation"
        }
    },
];


export default {
    name: "Index",
    components: {
        EditPop,
        TableList,
        Form
    },
    data() {
        return {
			is_all: 3,
			department_ids: [],
			file_type: '',
			visibleTips: false,
			docUrl: '',
			nameplate_image: [],
				files_list: [],
			get_table_list: getHelpList,
			config:this.$config,
            status_list: this.$config.status_list,
            columns,
            visible: false,
            form_data_seo: {
                ...this.$config.form_data_seo,
                list: [
                    {
                        type: "select",
                        name: "cate_id",
                        title: "帮助分类",
                        placeholder: '',
                        options: {

                        },
                        list: []
                    },
                    {
                        type: "text",
                        name: "title",
                        title: "帮助标题",
                        options: {},
                    },
                    {
                        type: "select",
                        name: "status",
                        title: "状态",
                        placeholder: '',
                        options: {

                        },
                        list: this.$config.status_list
                    },
                ],
            },
            form_data: {
                title: '添加',
                list: [
                    {
                        type: 'text',
                        name: 'id',
                        hidden: true,
                        options: {},
                    },
                    {
                        type: 'select',
                        name: 'cate_id',
                        title: '帮助分类',
                        options: {},
                        list: [],
                    },
                    {
                        type: 'text',
                        name: 'title',
                        title: '帮助标题',
                        options: {},
                    },
                    {
                        type: 'text',
                        name: 'sort',
                        title: '排序',
                        options: {},
					},
					{
                        type: "radio",
                        name: "status",
                        title: "状态",
                        placeholder: '',
                        options: {

                        },
                        list: this.$config.status_list
                    },
					{
						type: "slot",
						name: "files",
						title: "公告附件",
						options: {},
					
					},
                    {
                        type: 'editor',
                        name: 'content',
                        title: '内容',
                        options: {},
                    },
                ]
            }
        };
    },


    async created() {
        // this.get_list();

        this.get_cate_list();
    },
    methods: {
		seeFileFun(file) {
			this.file_type = file.type
			this.docUrl = file.url.replace("?x-oss-process=style/visit", "")
			if (file.type != 'pdf' && file.type != 'png' && file.type != 'jpg' && file.type != 'jpeg') {
				this.docUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(this.docUrl)}`
			}
			this.visibleTips = true
		},
		async handlePreview(file) {
			this.previewImage = file.url || file.response.url;
			this.previewVisible = true;
		},
		handleChangeImg(e) {
		
			this.nameplate_image = e ? e.fileList : [];
		},
		
		getSuffix(fileName) {
		    let pos = fileName.lastIndexOf(".");
		    let suffix = '';
		    if (pos != -1) {
		        suffix = fileName.substring(pos);
		    }
		    return suffix;
		},
		
		//图片上传
		customRequest(info) {
		    const size = info.file.size;
		    const fileName = info.file.name.toLowerCase(); 
		    // if(fileName.endsWith('pptx') || fileName.endsWith('pdf') || fileName.endsWith('mp3') || fileName.endsWith('m4a')) {
		    //     if(size / 1024 / 1024 > 100) {
		    //         message.error('文件大小超过100M，请压缩后上传')
		    //         return
		    //     }
		    // }else if(fileName.endsWith('flv') || fileName.endsWith('mp4')) {
		    //     if(size / 1024 / 1024 / 1024 > 5) {
		    //         message.error('视频文件大小超过5G，请压缩后上传')
		    //         return
		    //     }
		    // }else {
		    //     // message.error('文件格式有误，请选择PPTX、PDF、MP3、MP4、M4A、FLV格式！')
		    //     return
		    // }
		    getUploadOSSConfig().then(res => {
		        this.submit_oss_upload(res.data, info)
		    })
		},
		
		submit_oss_upload(resDate, file) {
		    console.log(resDate, file)
		    let name = new Date().getTime() + '' + Math.random().toFixed(6).slice(-6)
		    let filename = md5(name) + this.getSuffix(file.file.name);
		    let formData = new FormData();
		    //注意formData里append添加的键的大小写
		    formData.append('key', resDate.dir + filename); //存储在oss的文件路径
		    formData.append('OSSAccessKeyId', resDate.accessid); //accessKeyId
		    formData.append('policy', resDate.policy); //policy
		    formData.append('Signature', resDate.signature); //签名
		    formData.append("file", file.file);
		    formData.append('success_action_status', '200'); //成功后返回的操作码
		    let file_names = file.file.name.split('.')
		    //使用表单提交数据
		    this.$axios({
		        url: resDate.host,
		        header: {
		            'Content-Type': 'multipart/form-data'
		        },
		        method: 'post',
		        data: formData,
		        onUploadProgress: (e) => {
		           
		        }
		    }).then(res => {
				this.files_list.push({name:file.file.name,url:resDate.host + '/' + resDate.dir + filename,size:file.file.size})
		    })
		},
		getSuffix(fileName) {
		    let pos = fileName.lastIndexOf(".");
		    let suffix = '';
		    if (pos != -1) {
		        suffix = fileName.substring(pos);
		    }
		    return suffix;
		},
		getAudioData(file) {
		    let url = URL.createObjectURL(file.file);
		    let audioElement = new Audio(url);
		    audioElement.addEventListener("loadedmetadata", () => {
		        this.data.forEach(item=>{
		            if(item.uid == file.file.uid){
		                item.file_duration = parseInt(audioElement.duration) + 1
		            }
		        })
		    });
		},
		upload(e, item) {
			let that = this
			getUploadOSSConfig().then(res => {
				
			    // that.loading_state = true
			    that.submit_oss_upload(res,  e.file)
			})
		
		},
        add() {
			this.form_data.title = "添加"
            this.form_data.list.forEach(item => {
                item.options.initialValue = "";
                item.content = "";
            })

            this.visible = true;
        },
        edit(record) {
			this.form_data.title = "编辑"
            getHelp({
                data: {
                    id: record.id
                }
            }).then(res => {
                let data = res.data
                this.form_data.list.forEach(item => {
                    item.options.initialValue = data[item.name];
                })
				this.files_list = res.data.enclosure
                this.visible = true;
                this.form_data.list.forEach((item, index) => {
                    if (item.type == 'editor') {
                        this.form_data.list[index].content = data[item.name]
                    }
                    this.$nextTick(res => {
                        if (item.type == 'select') {
                            let val = {};
                            val[item.name] = data[item.name];

                            this.$refs.edit_pop.setFieldsValue(val)
                        }
                    })
                })
            })
        },
        del(record) {
            delHelp({
                data: {
                    id: record.id
                },
                info: true,
            }).then(res => {
                this.$refs.list.get_list();
            })
        },
        async get_cate_list() {
            cateList({

            }).then(res => {
                this.form_data.list.forEach(item => {
                    if (item.name == 'cate_id') {
                        item.list = res.data.list.map(val => {
                            return {
                                key: val.id,
                                value: val.title
                            }
                        });
                    }
                })
            })
        },
        submit(e) {
            let data = e.values;
            if (!data.id) {
                data.id = '';
            }
            changeHelp({
                data: {
                    ...data,
					enclosure:this.files_list
                },
                info: true,
            }).then(res => {
                this.visible = false;
                this.$refs.list.get_list();
            })
        },
    }
};
</script>

<style lang="less">
@import url("../../assets/less/app.less");
</style>